export const TRUSTEE_REPORT_TYPE = 'trustee_report_type';
export const OFFICE_REPORT_TYPE = 'office_report';
export const ESTATE_REPORT_TYPE = 'estate_report';
